export default __webpack_public_path__ + "static/media/avatar_32.b9d4760c.png";